module.exports = __webpack_public_path__ + "img/btnuploadicon.90000459.svg";